import { FormattedMessage, useIntl } from "react-intl";
import styles from "./FreeBooks.module.scss";
import { clsx } from "clsx";
import Swimlane from "../../../../common/core-ui/Swimlane.tsx";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { usePromotions } from "../../actions/explore-promotion/usePromotions.tsx";

interface Props {
  type?: "primary" | "secondary";
  title?: string;
  subtitle?: string;
}

export default function FreeBooks({
  type = "primary",
  title,
  subtitle,
}: Props) {
  const intl = useIntl();
  const { promotions } = usePromotions();
  const isPrimary = type === "primary";
  const isSecondary = !isPrimary;

  if (!promotions?.length) {
    return null;
  }

  return (
    <div className={clsx(isSecondary && styles.secondaryContainer)}>
      <h2
        className={clsx(
          isPrimary ? "template-h1" : "template-h2",
          styles.title
        )}
      >
        {title ?? intl.formatMessage({ defaultMessage: "Free Books" })}
      </h2>
      <div className={styles.subTitle}>
        {subtitle ??
          intl.formatMessage({
            defaultMessage: "Included in your account and ready to read.",
          })}
      </div>
      <Swimlane className={styles.swimlane} keepItemsReachable flexibleSize>
        {promotions.map((promo) => (
          <li key={promo.value}>
            <BaseLinkOrButton
              className={styles.cardBtn}
              to={`/explore/${promo.value}`}
            >
              <div
                className={clsx(
                  styles.card,
                  isSecondary && styles.cardSecondary
                )}
              >
                <div className={styles.coverHolder}>
                  <img src={promo.cover} alt={""} aria-hidden={true} />
                </div>
                <div>
                  <div className={styles.cardTitleCount}>
                    {promo.count > 0 && (
                      <FormattedMessage
                        defaultMessage="{count, plural, =1 {1 title} other {# titles}}"
                        values={{
                          count: promo.count,
                        }}
                      />
                    )}
                  </div>
                  <div className={styles.cardTitle}>{promo.title}</div>
                  <div className={styles.cardDescription}>
                    {promo.description}
                  </div>
                </div>
              </div>
            </BaseLinkOrButton>
          </li>
        ))}
      </Swimlane>
    </div>
  );
}
